module.exports = __webpack_public_path__ + "static/media/mountBan.7576cabd.jpg";